class TabManager extends HTMLElement {
  buttons;

  connectedCallback() {
    document.addEventListener('DOMContentLoaded', () => {
      const id = this.id;
      this.buttons = this.querySelectorAll(`#${id} > .tab-header .tab-handle`);
      this.buttons.forEach(button => button.addEventListener('click', this.onButtonClick.bind(this)));

      console.log('buttons', this.id, this.buttons);
    });
  }

  onButtonClick(e) {
    const activeId = e.target.dataset.id;

    this.buttons.forEach(button => {
      button.classList.toggle('active', button.dataset.id === activeId);
    });

    const tabs = this.querySelectorAll(`#${this.id} > .tab-content`);
    console.log('tabs', this.id, tabs);

    tabs.forEach(tab => {
      tab.classList.toggle('active', tab.dataset.id === activeId);
    });
  }
}

if (!customElements.get('tab-manager')) {
  customElements.define('tab-manager', TabManager);
}